/** Workspace roles (blueprint §4), weakest first. */
export const ROLES = ["viewer", "analyst", "manager", "admin", "owner"] as const;
export type Role = (typeof ROLES)[number];

export function roleAtLeast(role: Role, min: Role): boolean {
  return ROLES.indexOf(role) >= ROLES.indexOf(min);
}

export const ROLE_LABELS: Record<Role, string> = {
  viewer: "Viewer",
  analyst: "Analyst",
  manager: "Manager",
  admin: "Admin",
  owner: "Owner",
};

/** What each role can do, in the words the Team screen uses. */
export const ROLE_CAN: Record<Role, string> = {
  viewer: "Read only",
  analyst: "Draft change sets, run simulations, reports, Copilot",
  manager: "Approve and publish change sets, edit rules",
  admin: "Connections, team, guardrails, autonomy levels",
  owner: "Everything, billing-level settings, delete workspace",
};
